/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Dialog_Text_To_Audio_Join_Broken_LinesInputs */

const en_dialog_text_to_audio_join_broken_lines = /** @type {(inputs: Dialog_Text_To_Audio_Join_Broken_LinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Join broken lines`)
};

const es_dialog_text_to_audio_join_broken_lines = /** @type {(inputs: Dialog_Text_To_Audio_Join_Broken_LinesInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unir líneas cortadas`)
};

/**
* | output |
* | --- |
* | "Join broken lines" |
*
* @param {Dialog_Text_To_Audio_Join_Broken_LinesInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const dialog_text_to_audio_join_broken_lines = /** @type {((inputs?: Dialog_Text_To_Audio_Join_Broken_LinesInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Dialog_Text_To_Audio_Join_Broken_LinesInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_dialog_text_to_audio_join_broken_lines(inputs)
	return en_dialog_text_to_audio_join_broken_lines(inputs)
});